import { Fragment } from 'react';
import { Text } from '../../../node/text';
import { getCachedTokenSize, } from '../tokenMeasureCache/tokenMeasureCache';
const flattenFragments = (elements) => elements.reduce((acc, element) => {
    if (element.type === Fragment) {
        acc.push(...flattenFragments(element.props.children));
    }
    if (element.type === Text) {
        acc.push(element);
    }
    return acc;
}, []);
export const baseTextParser = ({ offset, elements, width, onTextExceedsWidth, onTextFits, }) => {
    const state = {
        offset: Object.assign({}, offset),
    };
    const elementsAsArray = Array.isArray(elements) ? elements : [elements];
    return flattenFragments(elementsAsArray).reduce((acc, element, index, array) => {
        const isLastElement = index === array.length - 1;
        const { props } = element;
        const { text = '' } = props;
        const tokenSizes = [];
        if (text.length === 0) {
            return acc;
        }
        for (const token of text) {
            const { width: lastTokenWidth = 0, height: lastTokenHeight = 0 } = tokenSizes[tokenSizes.length - 1] || {};
            const { width: tokenWidth, height: tokenHeight } = getCachedTokenSize(token, props);
            tokenSizes.push({
                width: tokenWidth + lastTokenWidth,
                height: Math.max(tokenHeight, lastTokenHeight),
            });
            if (tokenWidth + lastTokenWidth + state.offset.x > width) {
                const { elements, offset } = onTextExceedsWidth({
                    element,
                    sizes: tokenSizes,
                    isLastElement,
                });
                state.offset = Object.assign({}, offset);
                acc.push(...elements);
                return acc;
            }
        }
        const { elements, offset } = onTextFits({
            element,
            sizes: tokenSizes,
            isLastElement,
        });
        state.offset = Object.assign({}, offset);
        acc.push(...elements);
        return acc;
    }, []);
};
